import React from 'react';
import { useQueryClient } from 'react-query';
import {makeStyles, useTheme, withStyles} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Popper from "@material-ui/core/Popper";
import _ from "underscore";

import { useCurrencies } from "../../../services/currencies";

/* eslint-disable no-use-before-define */
const styles = (theme) => ({
  popper: {
    maxWidth: "fit-content"
  },
  overrides: {
    // Style sheet name ⚛️
    MuiAutocomplete: {
      // Name of the rule
      input: {
        // Some CSS
        minWidth: '60',
      },
    },
  },
});

const CurrencyLookup = props => {
  const theme = useTheme();
  const classes = makeStyles(theme => ({
    readOnly: {
      color: theme.palette.text.primary
    }
  }))(theme);

  const queryClient = useQueryClient();
  const extraKeys = [];
  const records = useCurrencies({queryClient, useCache: true, extraKeys, showChildCurrencies: props.showChildCurrencies});

  const handleChange = (event, record) => {
    if (event.key === 'Enter') {
      event.stopPropagation()
    }
    if (props.returnType === "object") {
      const returnObject = { value: record.currencyCode, found: false, data: {}}
      if (record) {
        returnObject.found = true;
        returnObject.data = record;
      }
      props.onChange(returnObject);
    } else {
      if (!record) {
        props.onChange("");
      } else {
        props.onChange(record.currencyCode);
      }
    }
  }
  const handleInputChange = (event, value) => {
    if (!event || (event.type !== 'change' && !(event.type === 'blur' && value))) return;
    if (props.returnType === "object") {
      const returnObject = { value, found: false, data: {} }
      const record = _.findWhere(records, { currencyCode: value });
      if (record) {
        returnObject.found = true;
        returnObject.data = record;
      }
      props.onChange(returnObject);
    } else {
      props.onChange(value);
    }
  }

  const DropdownList = function (props) {
    return <Popper {...props} style={styles.popper} placement="bottom-start" />;
  };

  return (
    <Autocomplete
      id="currency-lookup"
      disableClearable={true}
      autoSelect={true}
      autoHighlight={true}
      inputValue={props.value}
      options={records.data||[]}
      PopperComponent={DropdownList}
      getOptionSelected={(option, value) => option.currencyCode === value.currencyCode}
      getOptionLabel={(option) => option.currencyCode}
      onChange={handleChange}
      onInputChange={handleInputChange}
      disabled={props.disabled||props.readOnly}
      renderOption={(option) => (
        <React.Fragment>
          {option.currencyCode} - {option.currencyName}
        </React.Fragment>
      )}
      style={{
        width: (props.width||"100%"),
      }}
      renderInput={(params) => {
        const extraProps = {};
        if (props.readOnly) {
          extraProps.className = classes.readOnly;
        }
        const inputProps = {
          ...props.inputProps,
          ...params.inputProps,
          ...extraProps,
          // value
        }
        return (<TextField
          {...params}
          label={props.label}
          placeholder={props.placeHolder}
          inputProps={{...inputProps}}
          InputLabelProps={{
            ...props.inputLabelProps,
          }}
        />)}}
    />
  )

}

export default withStyles(styles) (CurrencyLookup);
